const scriptUrlList = [
    "vendor/jquery/jquery-3.2.1.min.js",
    "vendor/animsition/js/animsition.min.js" ,
    "vendor/bootstrap/js/popper.js",
    "vendor/bootstrap/js/bootstrap.min.js",
    "vendor/select2/select2.min.js",
    "vendor/daterangepicker/moment.min.js",
    "vendor/daterangepicker/daterangepicker.js",
    "vendor/slick/slick.min.js",
    "js/slick-custom.js",
    "vendor/parallax100/parallax100.js",
    "vendor/isotope/isotope.pkgd.min.js",
    "vendor/sweetalert/sweetalert.min.js",
    "vendor/perfect-scrollbar/perfect-scrollbar.min.js",
    "js/main.js",
    "", "", "", "", ""
];

export default scriptUrlList;